import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { FuseSharedModule } from "@fuse/shared.module";
import { ToolbarShortcutsComponent } from "./toolbar-shortcuts.component";
import { MatButtonModule } from "@angular/material/button";
import { RouterModule } from "@angular/router";
import { MatMenuModule } from "@angular/material/menu";

@NgModule({
  declarations: [ToolbarShortcutsComponent],
  exports: [ToolbarShortcutsComponent],
  imports: [
    CommonModule,
    RouterModule,

    // fuse
    FuseSharedModule,

    // material
    MatIconModule,
    MatButtonModule,
    MatMenuModule
  ]
})
export class ToolbarShortcutsModule {}
